import { REPORT_MODES } from "./reportingConstants.mjs";

export const createEmptyReportingFilter = () => ({
  dateFrom: "",
  dateTo: "",
  statusCode: "",
  source: "",
  operatorNationalId: "",
  departmentGid: "",
  arrondissementGid: "",
  communeGid: "",
  sectionGid: "",
  constituencyGid: "",
  votingCenterGid: "",
});

const NUMERIC_FIELDS = Object.freeze([
  "applicationType",
  "statusCode",
  "source",
  "departmentGid",
  "arrondissementGid",
  "communeGid",
  "sectionGid",
  "constituencyGid",
  "votingCenterGid",
]);

export const normalizeReportingFilter = (filter) => {
  const normalized = {};

  for (const [key, value] of Object.entries(filter || {})) {
    if (value !== null && value !== undefined && value !== "") {
      normalized[key] = typeof value === "string" ? value.trim() : value;
    }
  }

  for (const field of NUMERIC_FIELDS) {
    if (normalized[field] === undefined) continue;

    const value = Number(normalized[field]);
    if (!Number.isFinite(value)) {
      throw new Error(`Invalid numeric reporting filter: ${field}`);
    }
    normalized[field] = value;
  }

  return normalized;
};

export const cloneReportingFilter = (filter) => ({
  ...createEmptyReportingFilter(),
  ...(filter || {}),
});

export const reportingFilterForMode = (filter, mode) => ({
  ...cloneReportingFilter(filter),
  applicationType: mode === REPORT_MODES.CORRECTION ? 2 : 1,
});

export const reportingFilterForOperators = (filter) => {
  const result = { ...cloneReportingFilter(filter) };
  delete result.applicationType;
  return result;
};

export const isCorrectionFilter = (filter) => Number(filter?.applicationType) === 2;

export const reportingResourceKey = (...parts) => JSON.stringify(parts);
